export default {
    name: 'v5-icon-refresh',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M514.9 907.3c-100.6 0-195.2-41.1-266.3-115.6-71.2-74.7-110.5-174-110.5-279.7v-16.8H69.7c-3.4 0-6.1-2.9-6.1-6.6 0-1.7.4-2.7 1.2-4l50.8-91.8 51.1-92.5c1-1.8 2.8-2.9 4.7-2.9 2.1 0 3.7 1 4.7 2.8l51.2 92.6 50.6 92c.9 1.5 1.3 3 1.3 4.2 0 3.6-2.8 6.6-6.1 6.6h-75.2v16.8c0 182.8 142.1 331.4 316.8 331.4 68.8 0 134.6-23 190.3-66.6l.4-.3.4-.4c5.6-5.6 12.8-8.7 20.3-8.7 16.6 0 30.1 14.4 30.9 32.7 0 8-3.2 16.1-8.7 22h-.2l-2.4 2.1c-.2.2-.4.3-.6.5l-.1.1c-.6.4-1.4 1-2.2 1.8-66.2 52.5-145 80.3-227.9 80.3zM853 662.8c-1.8 0-3.8-1.2-4.7-2.8l-50.7-92.5-50.6-91.7c-.9-1.5-1.3-3-1.3-4.2 0-3.6 2.8-6.6 6.1-6.6H828l-1.6-9.9c-26.1-159.4-157.4-275-312.3-275-59 0-116.5 17.1-166.3 49.5l-.3.2-.3.2c-5.1 4-11.1 6.1-17.2 6.1-16.8 0-30-14-30-31.9 0-12.2 5.8-22.7 15.6-28.1l.2-.1.3-.2c59.1-38.6 127.6-59 198-59 91.5 0 179.8 34.8 248.5 98.1 68.2 62.8 112.6 149 124.9 242.8l1 7.4h66.9c1.6 0 3 .6 3.9 1.7.9 1 1.3 2.4 1.1 3.9l-.1.5v.5c0 1.3-.4 2.7-1.2 4l-50.3 91.8-51.1 92.5c-1 1.7-2.7 2.8-4.7 2.8z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
